import React from 'react';
import Logo from './Logo';
import { Spinner } from './Spinner';

/** Full-screen auth bootstrap UI (session restore). */
export function AuthSessionLoading() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-navy"
      aria-busy="true"
      aria-live="polite"
    >
      <Logo size="lg" clickable={false} />
      <Spinner className="h-6 w-6 text-accent" />
    </div>
  );
}
